function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Lightning Alt Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.6095135,0.214054054 L14.7216238,0.219269719 C14.945209,0.240158853 15.1635521,0.323953668 15.3509189,0.473513514 L15.3509189,0.473513514 L15.4280263,0.541011129 C15.8206281,0.915602357 15.9136025,1.5165787 15.6382703,1.99459459 L15.6382703,1.99459459 L11.1223784,9.83091892 L13.644973,10.7098378 L13.7413724,10.7480785 C14.0865676,10.9027928 14.3383784,11.2141622 14.4168649,11.5887568 L14.4168649,11.5887568 L14.4331201,11.6911269 C14.4763108,12.0669189 14.34,12.4438919 14.0581622,12.7031351 L14.0581622,12.7031351 L2.19827027,23.6419459 L2.1105266,23.715375 C1.89943581,23.8752872 1.64594595,23.9552432 1.39394595,23.9552432 L1.39394595,23.9552432 L1.28156142,23.9500276 C1.05744291,23.9291384 0.838702703,23.8453436 0.651891892,23.6957838 L0.651891892,23.6957838 L0.574486707,23.628312 C0.180530815,23.2539912 0.0898187599,22.6553132 0.364540541,22.1772973 L0.364540541,22.1772973 L4.87913514,14.3396757 L2.35718919,13.4607568 L2.26121134,13.4223547 C1.91733333,13.2670541 1.66443243,12.9551892 1.58594595,12.5811892 L1.58594595,12.5811892 L1.56941704,12.4788315 C1.5253964,12.1031261 1.66264865,11.7266486 1.9427027,11.4668108 L1.9427027,11.4668108 L13.8045405,0.529945946 C14.0309189,0.321081081 14.3195676,0.214054054 14.6095135,0.214054054 L14.6095135,0.214054054 Z M14.6095135,1.40108108 L2.74832432,12.3398919 L6.62140541,13.6916757 L1.39394595,22.7688649 L13.2531892,11.8294054 L9.38010811,10.4776216 L14.6095135,1.40108108 Z",
  id: "lightning-alt-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Web-store",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hyperice-product-landing-page---PayGo-user-logged-in---Desktop",
  transform: "translate(-776.000000, -1745.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "EFFECTIVE-Copy",
  transform: "translate(-445.000000, 1371.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(1221.000000, 374.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "lightning-alt-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lightning-alt-path-1"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-30",
  fill: "currentcolor",
  mask: "url(#lightning-alt-mask-2)",
  points: "-5.72951351 29.891027 21.7316757 29.891027 21.7316757 -5.72108108 -5.72951351 -5.72108108"
})))));

var SvgLightningAlt = function SvgLightningAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 16 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightningAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightning-alt.8ea99ad0.svg";
export { ForwardRef as ReactComponent };